import { apiGetAuth, apiGetAuthWithCustomHeadersResponseType } from '@/utils/api'
import { API_SEARCH_MONETIZATION_REPORT } from '@/utils/api-url'
import { notificationDanger } from '@/utils/notification'

const state = () => {
  return {
    search_report_list: { data: [] },
    detail_search_report: {},
    meta_filter: {},
    toggle_modal_export: {
      targetModals: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_SEARCH_REPORT_LIST (state, payload) {
    state.search_report_list = payload
  },
  SET_DETAIL_SEARCH_REPORT (state, payload) {
    state.detail_search_report = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  },
  SET_TOGGLE_MODAL_EXPORT (state, payload) {
    state.toggle_modal_export = payload
  }
}

const actions = {
  async getListSearchReport (context, payload) {
    try {
      const response = await apiGetAuth(API_SEARCH_MONETIZATION_REPORT.LIST_SEARCH_MONETIZATION, payload)
      
      const fallbackData = response?.data || { data: [] }
      context.commit('SET_SEARCH_REPORT_LIST', fallbackData)
    } catch (error) {
      const safeMessage = error?.response?.data?.message || 'Failed to fetch search report list.'
      
      console.error('[Store Action Error: getListSearchReport]', error)
      notificationDanger(safeMessage)
      
      return Promise.reject(error)
    }
  },

  async getDetailSearchReport (context, payload) {
    const { campaign_id, ...params } = payload
    
    if (!campaign_id) {
      console.error('[Store Error: getDetailSearchReport] campaign_id is required.')
      return null
    }

    try {
      const response = await apiGetAuth(API_SEARCH_MONETIZATION_REPORT.DETAIL_SEARCH_MONETIZATION(campaign_id), params)
      
      const detailData = response?.data || {}
      context.commit('SET_DETAIL_SEARCH_REPORT', detailData)
      return detailData
    } catch (error) {
      const safeMessage = error?.response?.data?.message || 'Gagal mengambil data detail report.'
      
      console.error(`[Store Action Error: getDetailSearchReport] Failed for ID ${campaign_id}:`, error)
      
      notificationDanger(safeMessage)
      
      return Promise.reject(error)
    }
  },

  async exportSearchReport (context, payload) {
    const { campaign_id, ...params } = payload
    
    try {
      const response = await apiGetAuthWithCustomHeadersResponseType(
        API_SEARCH_MONETIZATION_REPORT.EXPORT_SEARCH_MONETIZATION(campaign_id), 
        params
      )
      
      return response
    } catch (error) {
      const safeMessage = error?.response?.data?.message || 'Failed to export report. Please try again.'
      
      console.error(`[Store Action Error: exportSearchReport] API failure for ID ${campaign_id}:`, error)
      
      notificationDanger(safeMessage)
      
      return Promise.reject(error)
    }
  }
}

const getters = {
  search_report_list (state) {
    return state.search_report_list
  },
  detail_search_report (state) {
    return state.detail_search_report
  },
  meta_filter (state) {
    return state.meta_filter
  },
  get_toggle_modal_export (state) {
    return state.toggle_modal_export
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
